export type AssistLimitFieldKey =
    | "maxUserMessageTokens"
    | "maxOutputTokens"
    | "maxContextTokens"
    | "dailyTokenLimit"
    | "monthlyTokenLimit"
    | "dailyRequestLimit";

export type AssistRateFieldKey = "inputUsdPerMillion" | "outputUsdPerMillion";

export type AssistFieldCopy<K extends string> = {
    key: K;
    label: string;
    hint: string;
};

export function assistLimitFields(scope: "company" | "platform"): AssistFieldCopy<AssistLimitFieldKey>[] {
    const eachPerson = scope === "company" ? "each person in this company" : "each person";
    return [
        {
            key: "maxUserMessageTokens",
            label: "Max user message tokens",
            hint: "The longest question someone can type. A normal question uses much less than this.",
        },
        {
            key: "maxOutputTokens",
            label: "Max output tokens",
            hint: "The longest answer Assist can write for one question.",
        },
        {
            key: "maxContextTokens",
            label: "Max context tokens",
            hint: "How much background Assist can use for one question, such as earlier chat or college notes. A higher number uses the daily allowance faster.",
        },
        {
            key: "dailyTokenLimit",
            label: "Daily token limit",
            hint: `How much Assist ${eachPerson} can use per day. This is per person, not a shared company total.`,
        },
        {
            key: "monthlyTokenLimit",
            label: "Monthly token limit",
            hint: `How much Assist ${eachPerson} can use in a calendar month.`,
        },
        {
            key: "dailyRequestLimit",
            label: "Daily request limit",
            hint: `How many questions ${eachPerson} can ask per day.`,
        },
    ];
}

export const assistRateFields: AssistFieldCopy<AssistRateFieldKey>[] = [
    {
        key: "inputUsdPerMillion",
        label: "Input USD / million tokens",
        hint: "Estimated cost when Assist reads a question and the background it uses to answer.",
    },
    {
        key: "outputUsdPerMillion",
        label: "Output USD / million tokens",
        hint: "Estimated cost when Assist writes an answer. Writing costs more than reading.",
    },
];
